import { apiClient } from "@/services/api/axiosClient";
import type { ApiResponse } from "@/services/api/api.types";
import { API_ENDPOINTS } from "@/services/api/endpoints";
import type { User } from "@/features/auth/model/authTypes";

export type UpdateProfileFieldsInput = {
  first_name: string;
  last_name: string;
  phone: string | null;
  mailing_address: string | null;
};

export type ProfileResult =
  | { status: "success"; data: User }
  | { status: "error"; message: string };

export const getProfile = async (): Promise<ProfileResult> => {
  try {
    const { data } = await apiClient.get<ApiResponse<{ user?: User } | User>>(
      API_ENDPOINTS.USER.PROFILE
    );
    const user = (data.data as { user?: User })?.user ?? (data.data as User);
    return { status: "success", data: user };
  } catch (error) {
    console.error(error, "getProfile error");
    return { status: "error", message: "Failed to get profile. Please try again." };
  }
};

export const updateProfile = async (payload: UpdateProfileFieldsInput): Promise<ProfileResult> => {
  try {
    const { data } = await apiClient.put<ApiResponse<{ user?: User } | User>>(
      API_ENDPOINTS.USER.PROFILE,
      payload
    );
    const user = (data.data as { user?: User })?.user ?? (data.data as User);
    return { status: "success", data: user };
  } catch (error) {
    console.error(error, "updateProfile error");
    return { status: "error", message: "Failed to update profile. Please try again." };
  }
};

export const updateProfileAvatar = async (payload: FormData): Promise<ProfileResult> => {
  try {
    const { data } = await apiClient.post<ApiResponse<{ user?: User } | User>>(
      API_ENDPOINTS.USER.AVATAR,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const user = (data.data as { user?: User })?.user ?? (data.data as User);
    return { status: "success", data: user };
  } catch (error) {
    console.error(error, "updateProfileAvatar error");
    return { status: "error", message: "Failed to update profile avatar. Please try again." };
  }
};
